import { Component, EventEmitter, input, Output } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { UserGridItemObject } from '@it2go/types';
import { userSexToEnumOptions } from '@libs/types/src/user/enum/user-sex.enum';
import { InputFileBtnComponent } from '../../common/input-file-btn/input-file-btn.component';
import { PersonInitialsPipe } from '../../../../shared/pipes/personInitials';
import { EmailInputComponent } from '../../../../../components/kit/input/text-input/email-input.component';
import { PasswordInputComponent } from '../../../../../components/kit/input/password-input/password-input.component';
import { TranslatePipe } from '@ngx-translate/core';
import { CheckInputComponent } from '../../../../../components/kit/input/check-input/check-input.component';
import { TextInputComponent } from '../../../../../components/kit/input/text-input/text-input.component';
import { SelectInputComponent } from '../../../../../components/kit/input/select-input/select-input.component';
import { CardComponent } from '../../../../../components/kit/card/card.component';
import { AvatarComponent } from '../../../../shared/components/kit/avatar/avatar.component';

@Component({
    selector: 'app-user-basic-info',
    templateUrl: './user-basic-info.component.html',
    styleUrl: './user-basic-info.component.scss',
    imports: [
        InputFileBtnComponent,
        PersonInitialsPipe,
        EmailInputComponent,
        PasswordInputComponent,
        TranslatePipe,
        CheckInputComponent,
        TextInputComponent,
        SelectInputComponent,
        CardComponent,
        AvatarComponent,
    ],
})
export class UserBasicInfoComponent {

    public form = input<FormGroup | null>();
    public passwordForm = input<FormGroup | null>();
    public user = input<UserGridItemObject | null>();
    public canEdit = input(false);
    public isProfileSettings = input(false);

    @Output() avatarUpload: EventEmitter<any> = new EventEmitter();

    protected readonly userSexToEnumOptions = userSexToEnumOptions;
}
